import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

// TODO: 替换为真实的 Android APK 下载地址
const ANDROID_DOWNLOAD_URL = "https://your-android-download-url.com/app.apk";

const FEATURES = [
  { icon: "ri-chat-3-line", key: "download.feature.msg", descKey: "download.feature.msg.desc", color: "#00D2A8" },
  { icon: "ri-vidicon-line", key: "download.feature.call", descKey: "download.feature.call.desc", color: "#F7C948" },
  { icon: "ri-group-line", key: "download.feature.group", descKey: "download.feature.group.desc", color: "#A78BFA" },
  { icon: "ri-file-transfer-line", key: "download.feature.file", descKey: "download.feature.file.desc", color: "#F97316" },
  { icon: "ri-shield-keyhole-line", key: "download.feature.encrypt", descKey: "download.feature.encrypt.desc", color: "#34D399" },
  { icon: "ri-notification-3-line", key: "download.feature.notify", descKey: "download.feature.notify.desc", color: "#60A5FA" },
];

export default function AndroidDownload() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg-base)" }}>
      <Navbar />
      <main className="pt-24 pb-20">
        {/* Hero */}
        <section className="relative py-20 overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: "linear-gradient(var(--grid-line) 1px, transparent 1px), linear-gradient(90deg, var(--grid-line) 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
          <div
            className="absolute top-0 left-1/3 w-[500px] h-[400px] rounded-full pointer-events-none"
            style={{ backgroundColor: "var(--glow-primary)", filter: "blur(100px)" }}
          />

          <div className="relative max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              {/* Left */}
              <div>
                <div
                  className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-6 border"
                  style={{
                    backgroundColor: "rgba(0, 210, 168, 0.10)",
                    borderColor: "rgba(0, 210, 168, 0.20)",
                  }}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-android-line" style={{ color: "var(--accent)" }}></i>
                  </div>
                  <span className="text-xs font-medium" style={{ color: "var(--accent)" }}>
                    {t("download.android.badge")}
                  </span>
                </div>

                <h1
                  className="text-4xl md:text-5xl font-extrabold leading-tight mb-5"
                  style={{ color: "var(--text-primary)" }}
                >
                  {t("download.android.title")}
                </h1>
                <p className="text-base leading-relaxed mb-8 max-w-lg" style={{ color: "var(--text-secondary)" }}>
                  {t("download.android.desc")}
                </p>

                {/* Download button */}
                <div className="flex flex-wrap gap-3 items-center">
                  <a
                    href={ANDROID_DOWNLOAD_URL}
                    className="inline-flex items-center gap-2.5 font-bold text-base px-8 py-4 rounded-2xl transition-colors cursor-pointer whitespace-nowrap"
                    style={{ backgroundColor: "var(--accent)", color: "var(--accent-text)" }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--accent-hover)")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--accent)")}
                  >
                    <i className="ri-download-2-line text-lg"></i>
                    {t("download.android.btn")}
                  </a>
                  <button
                    onClick={() => navigate("/download/ios")}
                    className="inline-flex items-center gap-2 text-sm px-6 py-4 rounded-2xl transition-colors cursor-pointer whitespace-nowrap border"
                    style={{
                      borderColor: "var(--border-hover)",
                      color: "var(--text-primary)",
                      backgroundColor: "transparent",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--text-primary)")}
                    onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                  >
                    <i className="ri-apple-line"></i>
                    iOS Version
                  </button>
                </div>

                {/* Tip */}
                <p className="text-xs mt-4 flex items-center gap-1.5" style={{ color: "var(--text-muted)" }}>
                  <i className="ri-information-line"></i>
                  {t("download.android.tip")}
                </p>
              </div>

              {/* Right: phone mockup */}
              <div className="flex items-center justify-center">
                <div className="relative">
                  <div
                    className="w-64 h-[520px] rounded-[44px] overflow-hidden relative border-2"
                    style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-color)" }}
                  >
                    <div
                      className="absolute top-3 left-1/2 -translate-x-1/2 w-16 h-4 rounded-full z-10"
                      style={{ backgroundColor: "var(--bg-base)" }}
                    ></div>
                    <img
                      src="https://readdy.ai/api/search-image?query=mobile%20messaging%20app%20chat%20interface%20dark%20theme%20green%20accent%20color%20modern%20instant%20messaging%20UI%20with%20messages%20bubbles%20contacts%20list%20clean%20minimal%20design&width=256&height=516&seq=android-screen1&orientation=portrait"
                      alt="Android app screenshot"
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-20 h-1 rounded-full" style={{ backgroundColor: "var(--text-muted)" }}></div>
                  </div>
                  {/* Glow */}
                  <div
                    className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-48 h-12 pointer-events-none"
                    style={{ backgroundColor: "rgba(0, 210, 168, 0.15)", filter: "blur(16px)" }}
                  />
                  {/* Floating badge */}
                  <div
                    className="absolute -right-8 top-16 rounded-2xl px-4 py-3 border"
                    style={{
                      backgroundColor: "var(--bg-surface)",
                      borderColor: "rgba(0, 210, 168, 0.25)",
                    }}
                  >
                    <div className="flex items-center gap-2.5">
                      <div
                        className="w-8 h-8 flex items-center justify-center rounded-xl"
                        style={{ backgroundColor: "rgba(0, 210, 168, 0.15)" }}
                      >
                        <i className="ri-android-line" style={{ color: "var(--accent)" }}></i>
                      </div>
                      <div>
                        <div className="text-xs font-semibold" style={{ color: "var(--text-primary)" }}>Android 8.0+</div>
                        <div className="text-xs" style={{ color: "var(--text-secondary)" }}>Supported</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features grid */}
        <section className="py-20" style={{ backgroundColor: "var(--bg-subtle)" }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <h2 className="text-2xl md:text-3xl font-extrabold mb-3" style={{ color: "var(--text-primary)" }}>
                Core Features
              </h2>
              <p className="text-sm max-w-md mx-auto" style={{ color: "var(--text-secondary)" }}>
                Everything you need for modern team communication
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {FEATURES.map((f) => (
                <div
                  key={f.key}
                  className="rounded-2xl p-6 transition-all group border"
                  style={{
                    backgroundColor: "var(--bg-surface)",
                    borderColor: "var(--border-color)",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.borderColor = "var(--border-hover)")}
                  onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--border-color)")}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl mb-4 transition-all group-hover:scale-105"
                    style={{ backgroundColor: `${f.color}15` }}
                  >
                    <i className={`${f.icon} text-lg`} style={{ color: f.color }}></i>
                  </div>
                  <h3 className="text-base font-semibold mb-1.5" style={{ color: "var(--text-primary)" }}>
                    {t(f.key)}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                    {t(f.descKey)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Screenshots */}
        <section className="py-20" style={{ backgroundColor: "var(--bg-base)" }}>
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-2xl font-extrabold text-center mb-12" style={{ color: "var(--text-primary)" }}>
              App Screenshots
            </h2>
            <div className="flex gap-5 justify-center flex-wrap">
              {[
                { seq: "ss-android-1", label: "Chats" },
                { seq: "ss-android-2", label: "Contacts" },
                { seq: "ss-android-3", label: "Video Call" },
                { seq: "ss-android-4", label: "Group Chat" },
              ].map((s) => (
                <div key={s.seq} className="flex flex-col items-center gap-3">
                  <div
                    className="w-40 h-[300px] rounded-3xl overflow-hidden border"
                    style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-color)" }}
                  >
                    <img
                      src={`https://readdy.ai/api/search-image?query=mobile%20app%20dark%20theme%20instant%20messaging%20chat%20$%7Bs.label%7D%20interface%20modern%20UI%20green%20accent%20minimal%20clean&width=160&height=300&seq=${s.seq}&orientation=portrait`}
                      alt={s.label}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <p className="text-xs" style={{ color: "var(--text-secondary)" }}>{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="py-16" style={{ backgroundColor: "var(--bg-subtle)" }}>
          <div className="max-w-2xl mx-auto px-6 text-center">
            <div
              className="rounded-3xl p-10 border"
              style={{ backgroundColor: "var(--bg-surface)", borderColor: "var(--border-color)" }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-5"
                style={{ backgroundColor: "rgba(0, 210, 168, 0.10)" }}
              >
                <i className="ri-android-line text-2xl" style={{ color: "var(--accent)" }}></i>
              </div>
              <h3 className="text-2xl font-extrabold mb-3" style={{ color: "var(--text-primary)" }}>
                {t("download.android.cta.title")}
              </h3>
              <p className="text-sm mb-8" style={{ color: "var(--text-secondary)" }}>
                {t("download.android.cta.desc")}
              </p>
              <a
                href={ANDROID_DOWNLOAD_URL}
                className="inline-flex items-center gap-2.5 font-bold text-base px-8 py-4 rounded-2xl transition-colors cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: "var(--accent)", color: "var(--accent-text)" }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--accent-hover)")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--accent)")}
              >
                <i className="ri-download-2-line text-lg"></i>
                {t("download.android.btn")}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}